module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row main-row",
    attrs: {
      "id": "myMain"
    }
  }, [_c('div', {
    staticClass: "hero",
    staticStyle: {
      "max-height": "600px"
    }
  }, [_c('div', {
    staticClass: "hero-text"
  }, [_c('h1', {
    staticClass: "title-text text-center",
    staticStyle: {
      "margin-bottom": "0px!important",
      "padding-bottom": "0px!important"
    }
  }, [_vm._v("Find the perfect Sitter")]), _vm._v(" "), (_vm.countryDataComp.CountryId) ? _c('div', {
    staticClass: "row find-container",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('p', {
    staticClass: "hidden-xs text-center",
    staticStyle: {
      "margin-top": "0px",
      "font-size": "15px",
      "color": "#656565"
    }
  }, [_vm._v("Cat and dog boarding just got awesome ")]), _vm._v(" "), _c('p', {
    staticClass: " hidden-sm hidden-md hidden-lg text-center ",
    staticStyle: {
      "font-size": "14px",
      "margin-top": "0px",
      "color": "#656565"
    }
  }, [_vm._v("Cat and dog boarding just got awesome ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin": "1px",
      "padding": "1px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.citiesList) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryDataComp.cityId),
      expression: "queryDataComp.cityId"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "id": "citySelect",
      "required": "",
      "name": "citySelect",
      "placeholder": "Select City"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchSitters()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.queryDataComp, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select a City")]), _vm._v(" "), _vm._l((_vm.citiesList), function(city) {
    return _c('option', {
      domProps: {
        "value": city.CityId
      }
    }, [_vm._v("\n                  " + _vm._s(city.CityName) + "\n                ")])
  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1px",
      "padding": "1px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-block btn-title-big hidden-xs fix-button  hidden-sm",
    on: {
      "mouseover": function($event) {
        _vm.active = true
      },
      "mouseleave": function($event) {
        _vm.active = false
      },
      "click": function($event) {
        _vm.searchSitters()
      }
    }
  }, [_vm._v(" Search   "), _c('i', {
    staticClass: "animated bounceIn fa fa-paw "
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg btn-block btn-title-big hidden-md hidden-lg",
    on: {
      "mouseover": function($event) {
        _vm.active = true
      },
      "mouseleave": function($event) {
        _vm.active = false
      },
      "click": function($event) {
        _vm.searchSitters()
      }
    }
  }, [_vm._v(" Search "), _c('i', {
    staticClass: "animated bounceIn fa fa-paw "
  })])])]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default nav-bottom paw"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._l((5), function(n) {
    return _c('i', {
      staticClass: "fa fa-star fa-2x inline",
      staticStyle: {
        "color": "#ffd118",
        "margin-top": "10px",
        "margin-bottom": "10px"
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.staycationDataComp.ReviewsCount) + ") Pet parent verified reviews")])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.staycationDataComp.SittersImages != null) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-6 "
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Recently joined Pet Buddies")]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.staycationDataComp.SittersImages), function(item) {
    return _c('div', {
      staticClass: "carousel-cell-sitter"
    }, [_c('img', {
      staticClass: "carousel-image",
      attrs: {
        "alt": "Dupaws Cute Pet",
        "src": item.Path
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "centered"
    }, [_c('span', {
      staticClass: "span-centered"
    }, [_vm._v(_vm._s(item.Name))])])])
  }))], 1), _vm._v(" "), _c('br', {
    staticClass: "hidden-sm hidden-md hidden-lg"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 "
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Recently completed a stay")]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.staycationDataComp.PetsImages), function(item) {
    return _c('div', {
      staticClass: "carousel-cell-pet"
    }, [_c('img', {
      staticClass: "carousel-image",
      attrs: {
        "alt": "Dupaws Cute Pet",
        "src": item.Path
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "centered"
    }, [_c('span', {
      staticClass: "span-centered"
    }, [_vm._v(_vm._s(item.Name))])])])
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div'), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "hidden-md hidden-lg",
    staticStyle: {
      "font-size": "medium"
    }
  }, [_vm._v("Dupaws primary focus is making it more convenient and affordable to find a real home for your cat or dog, we facilitate all the needed details that both pet parent or pet sitter needs, including creating cat or dog profiles, multiple bookings tracking, online chat, sms and email notifications, customer reviews, pricing and more.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center hidden-sm hidden-xs",
    staticStyle: {
      "font-size": "medium"
    }
  }, [_vm._v("Dupaws primary focus is making it more convenient and affordable to find a real home for your cat or dog, we facilitate all the needed details that both pet parent or pet sitter needs, including creating cat or dog profiles, multiple bookings tracking, online chat, sms and email notifications, customer reviews, pricing and more.")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3"
  }, [_c('hr'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-block ",
    staticStyle: {
      "font-size": "24px!important"
    },
    on: {
      "click": function($event) {
        _vm.searchSitters()
      }
    }
  }, [_vm._v("Find Sitters "), _c('i', {
    staticClass: "fa fa-paw"
  })]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
  }, [_vm._m(10), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-block ",
    staticStyle: {
      "font-size": "24px!important"
    },
    on: {
      "click": function($event) {
        _vm.goBecomeSitter()
      }
    }
  }, [_vm._v("Become a Sitter")])])])]), _vm._v(" "), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-center "
  }, [_vm._v("The next level of cat and dog boarding  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('img', {
    staticClass: "img img-responsive",
    attrs: {
      "alt": "Dupaws Cute Pet",
      "src": "https://www.dupaws.com/services/images/site/petsbag.jpg",
      "height": "300"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('p', {
    staticStyle: {
      "font-size": "medium"
    }
  }, [_vm._v("\n  Are you always traveling with limited options on who to watch your pet? We know it can be a daunting task for pet parents to find a trusted and passionate person to look for their pets, thats why we created Dupaws.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "medium"
    }
  }, [_vm._v("Dupaws is an online platform that allows you to quickly find a pet buddy in your area or community to stay with your pet while you are away to ensure stress free stay for your pet and peace of mind for you, think of it as the airbnb for pets.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "font-size": "medium"
    }
  }, [_c('i', {
    staticClass: "fa fa-quote-left fa-1x"
  }), _vm._v(" She was great, welcoming, friendly, sending me videos of Lucky to know how is he doing, it truly shows her love for dogs ... i was feeling comfortable leaving my Lucky with her. I could see my dog was enjoying there. Surely will contact her again. "), _c('i', {
    staticClass: "fa fa-quote-right fa-1x"
  })])]), _vm._v(" "), _c('p', [_vm._v("Lucie N")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.dupaws.com/pub/reviews"
    }
  }, [_vm._v("Read more reviews")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default nav-bottom paw"
  }, [_c('h2', {
    staticClass: "text-center "
  }, [_vm._v("How it works")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-bottom": "20px",
      "padding-top": "20px",
      "background-color": "rgba(255, 254, 254, 0.72)"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "step1"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('small', {
    staticClass: "text-muted text-center"
  }, [_vm._v("Go through profiles, compare ratings, prices & more")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "step2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('small', {
    staticClass: "text-muted text-center"
  }, [_vm._v("Schedule a meet and greet in person before confirming")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "step3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('small', {
    staticClass: " text-muted text-center"
  }, [_vm._v("Choose terms of payment that suits you and the sitter.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default nav-bottom paw"
  }, [_c('h2', {
    staticClass: "text-center "
  }, [_vm._v("Featured In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-bottom": "20px",
      "padding-top": "20px",
      "background-color": "rgba(255, 254, 254, 0.72)"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-2 remove-margins"
  }, [_c('div', {
    staticClass: "news1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2 remove-margins"
  }, [_c('div', {
    staticClass: "news2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2 remove-margins"
  }, [_c('div', {
    staticClass: "news3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2 remove-margins"
  }, [_c('div', {
    staticClass: "news4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2 remove-margins"
  }, [_c('div', {
    staticClass: "news5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2 remove-margins"
  }, [_c('div', {
    staticClass: "news6"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('p', {
    staticClass: "text-center ",
    staticStyle: {
      "font-size": "larger",
      "margin-top": "15px"
    }
  }, [_vm._v("Why Dupaws?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('hr', {
    staticStyle: {
      "margin-top": "5px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Pamper your furry baby")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('small', {
    staticClass: "text-center"
  }, [_vm._v("or")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Join our awesome community")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f5ecfe1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 632
// module chunks = 2